import React from "react";

/* eslint-disable eqeqeq */
import Pagination from "../../../../common/Pagination";
import BootstrapTable from "react-bootstrap-table-next";
import DocumentRevision from "./DocumentRevision";
import axios from "axios";
import { imageDefaultPrefixPath } from "../../../../../config";
import { toast } from "react-toastify";
import DocumentListActionButton from "./DocumentListActionButton";
import Spin from "../../../../common/Spin";
import { formatNumber, formatSubcontractorName } from "../../../../common/Misc";
import { defaultBaseUrl } from "../../../../../APIConfig/Interceptor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare, faCaretDown, faCaretRight } from "@fortawesome/free-solid-svg-icons";
import ProgressPayment from "../../../reports/ProgressPayment";

const DocumentTypeList = ({
  type,
  searchParam,
  documentList,
  setLimit,
  setPage,
  documentListLoading,
  total,
  page,
  limit,
  to,
  from,
  fetchDocumentList,
  globalContactSelect,
  globalContractSelect,
  contractOptions,
  handleAdd,
}) => {
  //   const query = new URLSearchParams(location.search);

  const handleDownload = async (value) => {
    try {
      const response = await axios.get(`${value}`, {
        responseType: "blob",
      });
      const fileData = response.data;
      const url = window.URL.createObjectURL(new Blob([fileData]));

      var a = document.createElement("a");
      a.href = url;
      var extention = value.split(".");
      var file = value.split("/");
      a.setAttribute(
        "download",
        file[file.length - 1] || "document" + extention
      );
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (e) {
      toast.error("File does not exist.");
    }
  };
  const handleView = async (value) => {
    window.open(`${imageDefaultPrefixPath}${value}`, "_blank", "noreferrer");
  };

  const documentListGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: documentList[i]?.id,
        date: documentList[i]?.created_at
          ? documentList[i]?.created_at?.split(" ")?.[0]
          : "-",
        contractor_name: documentList[i]?.contact
          ? formatSubcontractorName(documentList[i]?.contact)
          : "-",
        contract_number: documentList[i]?.contract
          ? documentList[i]?.contract?.contract_number
          : "-",
        contract_value_exc: documentList[i]?.contract?.contract_value_exc
          ? `$${formatNumber(
              Number(documentList[i]?.contract?.contract_value_exc)
            )}`
          : "-",
        contract_value: documentList[i]?.contract?.contract_value
          ? `$${formatNumber(
              Number(documentList[i]?.contract?.contract_value)
            )}`
          : "-",
        // pta_closing_balance: documentList[i]?.contract?.closing_balance_pta
        //   ? `$${formatNumber(
        //       Number(documentList[i]?.contract?.closing_balance_pta)
        //     )}`
        //   : "$0.00",
        document_number: documentList[i]?.document_number
          ? documentList[i]?.document_number
          : "-",
        document_file_name: documentList[i]?.document ? (
          <div
            style={{ cursor: "pointer" }}
            onClick={() => {
              window.open(documentList[i]?.document, "_blank");
            }}
            title={documentList[i]?.document}
          >
            {documentList[i]?.document?.includes(defaultBaseUrl()) ? (
              documentList[i]?.document?.split("/")?.slice(-1)
            ) : (
              <span>
                Open Link <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
              </span>
            )}
          </div>
        ) : (
          ""
        ),
        approved_amount:
          type?.value == 3
            ? documentList[i]?.payment_schedule?.approved_amount
              ? `$${formatNumber(
                  Number(documentList[i]?.payment_schedule?.approved_amount)
                )}`
              : documentList[i]?.payment_claim?.total_claimed_amount
              ? `$${formatNumber(
                  Number(documentList[i]?.payment_claim?.total_claimed_amount)
                )}`
              : ""
            : "-",
        document: documentList[i]?.document,
        document_type:
          type?.value == 3
            ? documentList[i]?.payment_claim_id
              ? "Payment claim"
              : documentList[i]?.payment_schedule_id
              ? "Payment Scheduled"
              : type?.label
              ? type?.label
              : ""
            : type?.value == 4
            ? documentList[i]?.payment_claim_id
              ? `${type?.label} (Payment claim)`
              : documentList[i]?.payment_schedule_id
              ? `${type?.label} (Payment Scheduled)`
              : type?.label
              ? type?.label
              : ""
            : type?.label
            ? type?.label
            : "",
        action: (
          <>
            <DocumentListActionButton
              document={documentList[i]?.document}
              id={documentList[i]?.id}
              handleDownload={() =>
                documentList[i]?.document?.includes(defaultBaseUrl())
                  ? handleDownload(documentList[i]?.document)
                  : window.open(documentList[i]?.document, "_blank")
              }
              handleView={() => handleView(documentList[i]?.document)}
              type={type}
              handleAdd={handleAdd}
              data={documentList[i]}
            />
          </>
        ),
      });
    }
    return items;
  };

  const documentList2Generator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: documentList[i]?.id,
        date: documentList[i]?.created_at
          ? documentList[i]?.created_at?.split(" ")?.[0]
          : "-",
        contractor_name: documentList[i]?.contact
          ? formatSubcontractorName(documentList[i]?.contact)
          : "-",
        contract_number: documentList[i]?.contract_number
          ? documentList[i]?.contract_number
          : "-",
        contract_value_exc: documentList[i]?.contract_value_exc
          ? `$${formatNumber(Number(documentList[i]?.contract_value_exc))}`
          : "-",
        contract_value: documentList[i]?.contract_value
          ? `$${formatNumber(Number(documentList[i]?.contract_value))}`
          : "-",
        // pta_closing_balance: documentList[i]?.closing_balance_pta
        //   ? `$${formatNumber(Number(documentList[i]?.closing_balance_pta))}`
        //   : "$0.00",
        approved_amount:
          type?.value == 3
            ? documentList[i]?.payment_schedule?.approved_amount
              ? `$${formatNumber(
                  Number(documentList[i]?.payment_schedule?.approved_amount)
                )}`
              : documentList[i]?.payment_claim?.total_claimed_amount
              ? `$${formatNumber(
                  Number(documentList[i]?.payment_claim?.total_claimed_amount)
                )}`
              : ""
            : "-",
        document_number: documentList[i]?.document?.document_number
          ? documentList[i]?.document?.document_number
          : "-",
        document_file_name: documentList[i]?.document?.document ? (
          <div
            style={{ cursor: "pointer" }}
            onClick={() => {
              window.open(documentList[i]?.document?.document, "_blank");
            }}
            title={documentList[i]?.document?.document}
          >
            {documentList[i]?.document?.document?.includes(defaultBaseUrl()) ? (
              documentList[i]?.document?.document?.split("/")?.slice(-1)
            ) : (
              <span>
                Open Link <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
              </span>
            )}
          </div>
        ) : (
          ""
        ),
        document: documentList[i]?.document?.document,
        document_type: type ? type?.label : "",
        action: (
          <>
            <DocumentListActionButton
              document={documentList[i]?.document?.document}
              id={documentList[i]?.id}
              handleDownload={() =>
                documentList[i]?.document?.document?.includes(defaultBaseUrl())
                  ? handleDownload(documentList[i]?.document?.document)
                  : window.open(documentList[i]?.document?.document, "_blank")
              }
              handleView={() => handleView(documentList[i]?.document?.document)}
              type={type}
              handleAdd={handleAdd}
              data={documentList[i]}
            />
          </>
        ),
      });
    }
    return items;
  };

  const documentData =
    type?.value == 2
      ? documentList2Generator(documentList?.length)
      : documentListGenerator(documentList?.length);

  // eslint-disable-next-line no-unused-vars
  const expandRow = {
    renderer: (row) => (
      <>
        <DocumentRevision id={row?.key} />{" "}
      </>
    ),
    onlyOneExpanding: true,
    showExpandColumn: true,
    expandByColumnOnly: true,
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return (
          <b>
            <FontAwesomeIcon icon={faCaretDown} />
          </b>
        );
      }
      return (
        <b>
          <FontAwesomeIcon icon={faCaretRight} />
        </b>
      );
    },
  };

  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchDocumentList(globalContactSelect, globalContractSelect, limit, 1);
  };

  const columns =
    type?.value == 3
      ? [
          {
            dataField: "date",
            text: "Date",
            style: {
              width: "100px",
            },
          },
          {
            dataField: "contractor_name",
            text: "Subcontractor Name",
          },
          {
            dataField: "contract_number",
            text: "Contract / Agreement Number",
          },
          {
            dataField: "contract_value_exc",
            text: "Contract Value (Ex. GST)",
          },
          {
            dataField: "contract_value",
            text: "Contract Value (Inc. GST)",
          },
          {
            dataField: "approved_amount",
            text: "Approved Amount",
          },
          // {
          //   dataField: "pta_closing_balance",
          //   text: "Cumulative Total",
          // },
          // {
          //   dataField: "document_number",
          //   text: "Document Number",
          // },
          {
            dataField: "document_type",
            text: "Document Type",
          },
          {
            dataField: "document_file_name",
            text: "Document File / URL",
          },
          {
            dataField: "action",
            text: "Action",
            align: "center",
            headerAlign: "center",
            style: { width: "97px" },
          },
        ]
      : [
          {
            dataField: "date",
            text: "Date",
            style: {
              width: "100px",
            },
          },
          {
            dataField: "contractor_name",
            text: "Subcontractor Name",
          },
          {
            dataField: "contract_number",
            text: "Contract / Agreement Number",
          },
          {
            dataField: "contract_value_exc",
            text: "Contract Value (Ex. GST)",
          },
          {
            dataField: "contract_value",
            text: "Contract Value (Inc. GST)",
          },
          // {
          //   dataField: "pta_closing_balance",
          //   text: "Cumulative Total",
          // },
          // {
          //   dataField: "document_number",
          //   text: "Document Number",
          // },
          {
            dataField: "document_type",
            text: "Document Type",
          },
          {
            dataField: "document_file_name",
            text: "Document File / URL",
          },
          {
            dataField: "action",
            text: "Action",
            align: "center",
            headerAlign: "center",
            style: { width: "97px" },
          },
        ];

  const handleChangePage = (page) => {
    setPage(page);
    fetchDocumentList(globalContactSelect, globalContractSelect, limit, page);
  };

  return type?.value !== 6 ? (
    <>
      <div className="custom-table tab-table">
        {documentListLoading && <Spin />}
        <BootstrapTable
          keyField="key"
          remote
          data={documentData}
          columns={columns}
          // expandRow={expandRow}
          noDataIndication="No Data Found"
        />
        <Pagination
          total={total}
          limit={parseInt(limit)}
          currentPage={page}
          updateLimit={handleUpdateLimit}
          updatePage={handleChangePage}
          from={from}
          to={to}
        />
      </div>
    </>
  ) : (
    <ProgressPayment
      contractOptions={contractOptions}
      globalContractSelect={globalContractSelect}
    />
  );
};
export default DocumentTypeList;
